import { AfterViewInit, Component, Input } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ConfigProvider } from "../../../config-provider.service";
import { RouterLink } from "@angular/router";
import { NgForOf } from "@angular/common";
import { MatButton } from "@angular/material/button";

@Component({
  selector: 'error-401',
  providers: [],
  styleUrls: ['./error-401.scss'],
  standalone: true,
  imports: [
    RouterLink,
    NgForOf,
    TranslateModule,
    MatButton
  ],
  templateUrl: './error-401.html'
})
export class Error401Component implements AfterViewInit {
    @Input()
    public message = '';
    @Input()
    public actions: any[] = [{ name: 'Okay_then...', link: '/' }];
    constructor(
        private config: ConfigProvider,
        private translateService: TranslateService
    ) {
    }

    public ngAfterViewInit() {
    }
}
